import { useState, useEffect } from "react";
import { momentFormat } from "@/utils/utils";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printVisible: boolean;
  setPrintVisible: (visible: boolean) => void;
}

export const PrintChangeLog = (props: PropsType) => {

  const { changeSupplierLogData, detailEditForm, detailLookForm } = usePurchaseEnquiryDetailsModel();
  const { printVisible, setPrintVisible } = props;
  const [dataSource, setDataSource] = useState<any[]>([]);
  const form = detailEditForm.id ? detailEditForm : detailLookForm;

  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  useEffect(() => {
    if (printVisible) {
      if (changeSupplierLogData.length > 0) {
        setDataSource(changeSupplierLogData);
      }
    }
  }, [printVisible])

  useEffect(() => {
    if (dataSource.length > 0) {
      console.log(form);
      console.log(detailEditForm);
      console.log(detailLookForm);
      print();
    }
  }, [dataSource])

  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    iframe.contentWindow?.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
      setDataSource([]);
      setPrintVisible(false);
    });

    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container" className="offerPrint-container">
        <div>
          <div style={{ textAlign: 'center', fontSize: 20, fontFamily: "FangSong", fontWeight: 'bold', marginTop: 40, marginBottom: 20 }}>
            {`${shopName}配件采购变更供应商审批表`}
          </div>
          <table className="mingxi" style={{ border: "1px solid black", width: "100%" }}>
            <thead>
              <tr style={{ lineHeight: 1 }}>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>序号</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>商品编码</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>商品名称</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>适用车型</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>规格型号</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>单位</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>数量</th>
                <th colSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>中标供应商及价格</th>
                <th colSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>变更供应商及价格</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>变更原因</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>所属站点</th>
                <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>变更时间</th>
              </tr>
              <tr style={{ lineHeight: 1 }}>
                <th style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>比选后确定供应</th>
                <th style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>送货价</th>
                <th style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>变更供应商</th>
                <th style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>变更送货价</th>
              </tr>
            </thead>
            <tbody>
              {dataSource.map((row, rowIndex) => (
                <tr key={rowIndex} style={{ lineHeight: 1 }}>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{rowIndex + 1}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.materialCode}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.materialName}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.vehicleModel}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.model}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.unitCode ? row.unitName : ''}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.num}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.oldSupplierName}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.oldPrice}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.newSupplierName}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.newPrice}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.note}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.shopName}</td>
                  <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{momentFormat(row.createTime)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: "flex", marginTop: 10, marginBottom: 5 }}>
            <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>发布人: {form.sendUser}</div>
            <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>审核人：{form.approver}</div>
            <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>主管领导：</div>
            <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>日期：{form.createTime && momentFormat(form.createTime)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};